<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left mb-2"
      cols="12"
      md="10"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $t($route.meta.pageTitle) }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ $t(item.text) }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      v-if="showPlannerSettings"
      class="content-header-right text-md-right d-md-block d-none mb-1"
      md="2"
      cols="12"
    >
      <b-dropdown
        right
        no-caret
        variant="flat-secondary"
        toggle-class="btn btn-primary btn-sm p-50"
      >
        <template #button-content>
          <feather-icon
            icon="SettingsIcon"
            size="16"
          />
        </template>

        <b-dropdown-item
          href="#"
          @click.prevent="setPlannerViewMode('scheduler')"
        >
          <feather-icon
            :icon="plannerViewMode === 'scheduler' ? 'CheckSquareIcon' : 'SquareIcon'"
            size="14"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('order.planner.view-modes.scheduler') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          href="#"
          @click.prevent="setPlannerViewMode('timeline')"
        >
          <feather-icon
            :icon="plannerViewMode === 'timeline' ? 'CheckSquareIcon' : 'SquareIcon'"
            size="14"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('order.planner.view-modes.timeline') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          href="#"
          @click.prevent="setPlannerShowBacklog(!plannerShowBacklog)"
        >
          <feather-icon
            :icon="plannerShowBacklog ? 'CheckSquareIcon' : 'SquareIcon'"
            size="14"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('order.planner.view-modes.backlog') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          href="#"
          @click.prevent="setPlannerShowStats(!plannerShowStats)"
        >
          <feather-icon
            :icon="plannerShowStats ? 'CheckSquareIcon' : 'SquareIcon'"
            size="14"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('order.planner.view-modes.stats') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          href="#"
          @click.prevent="setPlannerShowBuffer(!plannerShowBuffer)"
        >
          <feather-icon
            :icon="plannerShowBuffer ? 'CheckSquareIcon' : 'SquareIcon'"
            size="14"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('order.planner.view-modes.buffer') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          href="#"
          @click.prevent="setPlannerStickyHeaders(!plannerStickyHeaders)"
        >
          <feather-icon
            :icon="plannerStickyHeaders ? 'CheckSquareIcon' : 'SquareIcon'"
            size="14"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('order.planner.view-modes.sticky-headers') }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BCol,
  BDropdown,
  BDropdownItem,
  BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  loadOrderPlannerConfig,
  ORDER_PLANNER_CONFIG_EVENT,
  saveOrderPlannerConfig,
} from '@/views/orders/Planner/plannerConfig'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BCol,
    BDropdown,
    BDropdownItem,
    BRow,
  },
  data() {
    return {
      plannerConfig: loadOrderPlannerConfig(),
    }
  },
  computed: {
    plannerViewMode() {
      return this.plannerConfig.viewMode
    },
    plannerShowBuffer() {
      return this.plannerConfig.showBuffer
    },
    plannerStickyHeaders() {
      return this.plannerConfig.stickyHeaders
    },
    plannerShowBacklog() {
      return this.plannerConfig.showBacklog
    },
    plannerShowStats() {
      return this.plannerConfig.showStats
    },
    showPlannerSettings() {
      return this.$route?.name === 'order-planner'
    },
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener(ORDER_PLANNER_CONFIG_EVENT, this.syncPlannerConfig)
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener(ORDER_PLANNER_CONFIG_EVENT, this.syncPlannerConfig)
    }
  },
  methods: {
    syncPlannerConfig(event) {
      this.plannerConfig = event?.detail || loadOrderPlannerConfig()
    },
    setPlannerViewMode(viewMode) {
      if (viewMode === this.plannerViewMode) {
        return
      }

      this.plannerConfig = saveOrderPlannerConfig({
        viewMode,
        isViewModeManual: true,
      })
    },
    setPlannerShowBuffer(isVisible) {
      if (Boolean(isVisible) === this.plannerShowBuffer) {
        return
      }

      this.plannerConfig = saveOrderPlannerConfig({
        showBuffer: Boolean(isVisible),
      })
    },
    setPlannerShowBacklog(isVisible) {
      if (Boolean(isVisible) === this.plannerShowBacklog) {
        return
      }

      this.plannerConfig = saveOrderPlannerConfig({
        showBacklog: Boolean(isVisible),
      })
    },
    setPlannerShowStats(isVisible) {
      if (Boolean(isVisible) === this.plannerShowStats) {
        return
      }

      this.plannerConfig = saveOrderPlannerConfig({
        showStats: Boolean(isVisible),
      })
    },
    setPlannerStickyHeaders(enabled) {
      if (Boolean(enabled) === this.plannerStickyHeaders) {
        return
      }

      this.plannerConfig = saveOrderPlannerConfig({
        stickyHeaders: Boolean(enabled),
      })
    },
  },
}
</script>

<style lang="scss">
.content-header-right {
  position: relative;
  z-index: 30;
}

.content-header-right .dropdown-menu {
  z-index: 35;
}
</style>
